export enum TipoMovimiento {
   "",
   "D",
   "R",
}
